import AutoQuery from "servicestack/auto-query/auto-query";
import CartController from "emun.cart/cart.controller";
import PrintOrderOptions from "emun.order/order-print";
//import VendorReviewOrders from "emun.order/vendor-order-review";
import VendorShipmentPrompt from "emun.order/vendor-shipment-prompt";
import OrderLogDetail from "emun.order/order-log-detail";
import resolve from "ioc/resolve";
import orderConfig from "emun.order/order.config";
import orderPicker from "emun.order/picker/order-picker";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import ProcessPayment from "emun.order/process-payment";
import RetrieveTokenInfo from "emun.order/retrieve-token-info";
import RetrieveTokenExInfo from "emun.order/retrieve-tokenex-info";
import RetrieveHostedPCIInfo from "emun.order/retrieve-hostedpci-info";
import RetailerFormsPopup from "emun.order/retailer-forms-popup";
import dateRanges from "emun.order/order-container.date-ranges";
import OrderChangesPrompt from "emun.order/modify-order/order-changes-prompt";
import cartConfig from "emun.cart/cart.config";
import VendorReviewOrderPrompt from "emun.order/vendor-review-orders/vendor-review-order";

const $localStorage = resolve("$localStorage");

export const views = {
  list: "th-list",
  cards: "th",
};

/*export const filters = [
  { groupBy: "Status", title: "EmunStatus" },to
  { groupBy: "ErpStatus", title: "ERP Status" },
  { groupBy: "SourceId", title: "Source" },
  { date: "OrderedOn", title: "Order Date" },
  {
	groupBy: "CurrentRepName",
	title: "Rep # of Record",
	roles: [
	  "Administrator",
	  "Sales Manager",
	  "Manager",
	  "Web Admin",
	  "Corporate"
	]
  },
  { date: "ShipOn", title: "Ship Date" },
  { number: "GrandTotal", title: "Amount" },
  { groupBy: "ShowCodeName", title: "Show Code" },
  { groupBy: "Type" }
  //{ text: 'StatusNotIn', hidden: true, value: 'Quote' },
  //{ text: 'StatusContains', hidden: true },
];*/

export const sortOptions = {
  Id: "Order No.: Low to High",
  "-Id": "Order No: High to Low",
  "Status,-Id": "Status: A to Z",
  "-Status,-Id": "Status: Z to A",
  "PurchaseOrder,-Id": "PO#: Low to High",
  "-PurchaseOrder,-Id": "PO#: High to Low",
  "VendorLabel,-Id": "Vendor: A to Z",
  "-VendorLabel,-Id": "Vendor: Z to A",
  "CompanyName,-Id": "Customer: A to Z",
  "-CompanyName,-Id": "Customer: Z to A",
  "OrderedOn,-Id": "Order Date: Newest First",
  "-OrderedOn,-Id": "Order Date: Oldest First",
  "ShipOn,-Id": "Ship Date: Newest First",
  "-ShipOn,-Id": "Ship Date: Oldest First",
  "GrandTotal,-Id": "Amount: Low to High",
  "-GrandTotal,-Id": "Amount: High to Low",
};

export default class OrderContainerController extends CartController {
  constructor($cart) {
    super($cart);
    //console.debug("OrderContainerController", this);
    const $ctrl = this;
    const $location = resolve("$location");
    $ctrl.dateRanges = dateRanges;
    $ctrl.orderIds = [];
    if ($ctrl.repGroup && $ctrl.repGroup === "ALL") {
      $ctrl.repGroup = undefined;
    }
    $ctrl.dateRange =
      ($ctrl.$session.isShowroom() && !$ctrl.customer
        ? orderConfig.orderShowroomDateRangeSearch
        : $location.url().indexOf("/vendor-dashboard") > -1
        ? orderConfig.orderVendorDateRangeSearch
        : $location.url().indexOf("/cust") > -1
        ? orderConfig.orderCustDefaultDateRangeSearch
        : orderConfig.orderDefaultDateRangeSearch) || dateRanges[0].id;

    $ctrl.config = orderConfig;
    $ctrl.cartConfig = cartConfig;
    //console.info("salesrep", this.salesrep);
    //console.info("repId", this.repId);
    //console.info("mangerId", this.mangerId);
    $ctrl.$on("orderDeleted", () => $ctrl.query.load(true));
    $ctrl.$on("refreshGrid", () => $ctrl.query.load(true));
    $ctrl.$on("cartRemoved", (e, cart) => $ctrl.exitOrder(cart.id));
    $ctrl.$on(
      "cartItemRemoved",
      () =>
        !$ctrl.$state.current.name.startsWith("orders.detail") &&
        $ctrl.query.load(true)
    );
    $ctrl.$on(
      "cartItemQuantityChanged",
      () =>
        !$ctrl.$state.current.name.startsWith("orders.detail") &&
        $ctrl.query.load(true)
    );
    $ctrl.$on(
      "cartItemAdded",
      () =>
        !$ctrl.$state.current.name.startsWith("orders.detail") &&
        $ctrl.query.load(true)
    );
    $ctrl.$on("$stateChangeSuccess", (event, toState, { orderId } = {}) => {
      if (orderId) {
        $ctrl.orderId = orderId;
      }
    });
  }

  $onInit() {
    const $ctrl = this;

    $ctrl.bus = new ServiceBus();
    $ctrl.query = new AutoQuery($ctrl.getOrdersQueryOptions());
    if ($ctrl.useErpStatus) $ctrl.totalquery = new AutoQuery($ctrl.getOrderTotalsQueryOptionsErp());
    else $ctrl.totalquery = new AutoQuery($ctrl.getOrderTotalsQueryOptions());
    if (!$ctrl.mode) $ctrl.mode = "Order";
    if ($ctrl.config.showLineTotals) {
      $ctrl.lineTotalQuery = new AutoQuery({
        url: `QueryOrderLinesJoin.json?Sum=ExtendedTotal&GroupBy=CartItemStatus&Count=CartItemStatus&CartItemActive=1`,
        orderBy: null,
        disableQueryString: true,
        autoLoad: false,
        onLoaded: (args) => $ctrl.onLineTotalsLoaded(args),
      });
    }
    if ($ctrl.config.showLineDetailTotals) {
      $ctrl.lineTotalQuery = new AutoQuery({
        url: `QueryCartItemsJoin.json?Sum=OpenTotal,ShippedTotal&GroupBy=CartItemStatus&Count=CartItemStatus&CartItemActive=1`,
        orderBy: null,
        disableQueryString: true,
        autoLoad: false,
        onLoaded: (args) => $ctrl.onLineDetailTotalsLoaded(args),
      });
    }
  }

  exitOrder(OrderID) {
    let $ctrl = this;
    let orderId = OrderID !== undefined ? OrderID : $ctrl.order.id;
    $ctrl.$cart.exitOrder(orderId, true);
  }

  onOrdersLoaded(args) {
    const $ctrl = this;
    $ctrl.totalCount = $ctrl.query.total;
    $ctrl.totalquery.criteria = { ...$ctrl.query.criteria }; //pulses/678789731
    $ctrl.totalquery.criteria.StatusIn = [];
    //console.debug("onOrdersLoaded", { $ctrl, args });
    $ctrl.totalquery.load(true);
    if ($ctrl.config.showLineTotals || $ctrl.config.showLineDetailTotals) {
      $ctrl.lineTotalQuery.criteria = { ...$ctrl.query.criteria }; //pulses/678789731
      $ctrl.lineTotalQuery.criteria.searchHeader =
        $ctrl.lineTotalQuery.criteria.search;
      $ctrl.lineTotalQuery.criteria.search = undefined;
      //console.debug("$ctrl.lineTotalQuery.criteria", $ctrl.lineTotalQuery.criteria);
      $ctrl.lineTotalQuery.load(true);
    }
  }
  onOrderTotalsLoadedErp(args) {
    const $ctrl = this;
    $ctrl.totalSales = 0;

    $ctrl.statuses = [];
    args.results.forEach(function (obj) {
      $ctrl.statuses.push(obj);
      if (obj.sumGrandTotal) {
        if (
          $ctrl.query.criteria.ErpStatusIn == "" ||
          ($ctrl.query.criteria.ErpStatusIn &&
            $ctrl.query.criteria.ErpStatusIn.indexOf(obj.erpStatus) > -1)
        ) {
          $ctrl.totalSales += obj.sumGrandTotal;
        }
        // if (obj) {
        //   if (obj.status === "Cart") {
        //     $ctrl.statusCartCount = obj.countStatus;
        //   }
        //   if (obj.status === "Completed") {
        //     $ctrl.statusCompletedCount = obj.countStatus;
        //   }
        //   if (obj.status === "On Hold") {
        //     $ctrl.statusOnHoldCount = obj.countStatus;
        //   }
        //   if (obj.status === "Open") {
        //     $ctrl.statusOpenCount = obj.countStatus;
        //   }
        //   if (obj.status === "Review") {
        //     $ctrl.statusReviewCount = obj.countStatus;
        //   }
        // }
      }
    });
    //console.info("statuses", statuses);
    
  }

  onOrderTotalsLoaded(args) {
    const $ctrl = this;
    $ctrl.totalSales = 0;

    let statuses = [];
    args.results.forEach(function (obj) {
      statuses.push(obj.status);
      //if (obj.sumGrandTotal) {
        if (
          $ctrl.query.criteria.StatusIn == "" ||
          ($ctrl.query.criteria.StatusIn &&
            $ctrl.query.criteria.StatusIn.indexOf(obj.status) > -1)
        ) {
          $ctrl.totalSales += obj.sumGrandTotal;
        }

        if (obj) {
          if (obj.status === "Cart") {
            $ctrl.statusCartCount = obj.countStatus;
          }
          if (obj.status === "Completed") {
            $ctrl.statusCompletedCount = obj.countStatus;
          }
          if (obj.status === "On Hold") {
            $ctrl.statusOnHoldCount = obj.countStatus;
          }
          if (obj.status === "Open") {
            $ctrl.statusOpenCount = obj.countStatus;
          }
          if (obj.status === "Review") {
            $ctrl.statusReviewCount = obj.countStatus;
          }
          if (obj.status === "Cancelled") {
            $ctrl.statusCancelledCount = obj.countStatus;
          }
        }
      //}
    });
    //console.info("statuses", statuses);
    if (statuses.indexOf("Cart") < 0) {
      $ctrl.statusCartCount = 0;
    }
    if (statuses.indexOf("Completed") < 0) {
      $ctrl.statusCompletedCount = 0;
    }
    if (statuses.indexOf("On Hold") < 0) {
      $ctrl.statusOnHoldCount = 0;
    }
    if (statuses.indexOf("Open") < 0) {
      $ctrl.statusOpenCount = 0;
    }
    if (statuses.indexOf("Review") < 0) {
      $ctrl.statusReviewCount = 0;
    }
    if (statuses.indexOf("Cancelled") < 0) {
      $ctrl.statusCancelledCount = 0;
    }
    
  }

  onLineTotalsLoaded(args) {
    const $ctrl = this;
    $ctrl.openCount = 0;
    $ctrl.openTotal = 0;
    $ctrl.shippedCount = 0;
    $ctrl.shippedTotal = 0;
    args.results.forEach(function (obj) {
      if (obj.sumExtendedTotal) {
        if (obj.cartItemStatus === "Open") {
          $ctrl.openCount = obj.countCartItemStatus;
          $ctrl.openTotal = obj.sumExtendedTotal;
        }
        if (obj.cartItemStatus === "Shipped") {
          $ctrl.shippedCount = obj.countCartItemStatus;
          $ctrl.shippedTotal = obj.sumExtendedTotal;
        }
      }
    });
  }

  onLineDetailTotalsLoaded(args) {
    const $ctrl = this;
    $ctrl.openTotal = 0;
    $ctrl.shippedTotal = 0;
    args.results.forEach(function (obj) {
      if (obj.sumOpenTotal) {
        $ctrl.openTotal += obj.sumOpenTotal;
      }
      if (obj.sumShippedTotal) {
        $ctrl.shippedTotal += obj.sumShippedTotal;
      }
    });
  }

  getBaseUrl() {
    return "QueryOrdersJoin.json";
  }

  getOrdersQueryOptions() {
    const $ctrl = this;
    let url = "QueryCartsJoin.json?op=OrderContainer";
    const filters = [];

    const retailerId =
      $ctrl.retailerId || ($ctrl.customer && $ctrl.customer.id);

    if (retailerId) {
      //url = url + `?retailerId=${encodeURIComponent(retailerId)}`;
      filters.push({ groupBy: "ShipAddress", title: "Ship Address" });
    }

    orderConfig.filters.forEach(function (obj) {
      filters.push(obj);
    });
    //console.info("filters", filters);
    let statusNotIn = orderConfig.b2bStatusNotIn || "Delete,Deleted,Commitment,Interest";
    if ($ctrl.$session.isRetailer() && !orderConfig.showAllCartsForRetailers) {
      statusNotIn += ",Cart";
    }
    var showCodeCriteria = [];
    if (
      $ctrl.$session.isShowroom() &&
      $ctrl.$session.meta["ShowCodeName"] &&
      orderConfig.defaultShowCodeFilter
    ) {
      showCodeCriteria.push($ctrl.$session.meta["ShowCodeName"]);
    }
    
    let currentRepId = $ctrl.salesrep
    ? $ctrl.salesrep.id
    : $ctrl.repId
    ? $ctrl.repId
    : undefined;
    if ($ctrl.managerId !== undefined && $ctrl.managerId) {
      currentRepId = undefined;
    }
    return {
      url: url, //?StatusNotEqualTo=Cart',
      tagTotalsUrl: url,
      orderBy: "-OrderedOn,-Id",
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: {
        uploaded: $ctrl.uploaded,
        toUpload: $ctrl.toUpload,
        StatusNotIn: statusNotIn,
        [`Status${$ctrl.mode === "Quote" ? "StartsWith" : "NotEqualTo"}`]:
          "Quote",
        retailerId: retailerId,
        repGroup: $ctrl.repGroup,
        writingRepId: $ctrl.writingRepId ? $ctrl.writingRepId : undefined,
        managerId: $ctrl.managerId ? $ctrl.managerId : undefined,
        currentRepId: currentRepId,
        vendorId: $ctrl.vendor ? $ctrl.vendor.id : undefined,
        DateRange: $ctrl.dateRange,
        clientDateTime: moment().format("MM/DD/YYYY H:m:s Z"),
        ShowCodeNameIn: showCodeCriteria,
      },
      views,
      view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
      filters,
      //			filters: orderConfig.filters,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      scrollTop: orderConfig.scrollTop !== false,
      sortOptions,
      onLoaded: (args) => $ctrl.onOrdersLoaded(args),
    };
  }
  getOrderTotalsQueryOptionsErp() {
    const $ctrl = this;
    var url = "QueryOrdersJoin.json";
    var filters = [];

    const retailerId =
      $ctrl.retailerId || ($ctrl.customer && $ctrl.customer.id);

    if (retailerId) {
      //url += `?retailerId=${encodeURIComponent(retailerId)}`;
      url += "?Sum=GrandTotal&GroupBy=ErpStatus&Count=ErpStatus";
      filters.push({ groupBy: "ShipAddress", title: "Ship Address" });
    } else {
      url += "?Sum=GrandTotal&GroupBy=ErpStatus&Count=ErpStatus";
    }
    orderConfig.filters.forEach(function (obj) {
      filters.push(obj);
    });
    let statusNotIn = orderConfig.b2bStatusNotIn || "Delete,Deleted,Commitment,Interest";
    if ($ctrl.$session.isRetailer() && !orderConfig.showAllCartsForRetailers) {
      statusNotIn += ",Cart";
    }
    return {
      url: url,
      orderBy: null,
      disableQueryString: true,
      autoLoad: false,
      criteria: {
        uploaded: $ctrl.uploaded,
        toUpload: $ctrl.toUpload,
        ErpStatusNotIn: statusNotIn,
        [`ErpStatus${$ctrl.mode === "Quote" ? "StartsWith" : "NotEqualTo"}`]:
          "Quote",
        retailerId: retailerId,
        repGroup: $ctrl.repGroup,
        currentRepId: $ctrl.salesrep
          ? $ctrl.salesrep.id
          : $ctrl.repId
          ? $ctrl.repId
          : undefined,
        vendorId: $ctrl.vendor ? $ctrl.vendor.id : undefined,
        DateRange: $ctrl.dateRange,
      },
      fields: orderConfig.fields || undefined,
      filters,
      onLoaded: (args) => $ctrl.onOrderTotalsLoadedErp(args),
    };
  }

  getOrderTotalsQueryOptions() {
    const $ctrl = this;
    var url = "QueryOrdersJoin.json";
    var filters = [];

    const retailerId =
      $ctrl.retailerId || ($ctrl.customer && $ctrl.customer.id);

    if (retailerId) {
      //url += `?retailerId=${encodeURIComponent(retailerId)}`;
      url += "?Sum=GrandTotal&GroupBy=Status&Count=Status";
      filters.push({ groupBy: "ShipAddress", title: "Ship Address" });
    } else {
      url += "?Sum=GrandTotal&GroupBy=Status&Count=Status";
    }
    orderConfig.filters.forEach(function (obj) {
      filters.push(obj);
    });
    let statusNotIn = orderConfig.b2bStatusNotIn || "Delete,Deleted,Commitment,Interest";
    if ($ctrl.$session.isRetailer() && !orderConfig.showAllCartsForRetailers) {
      statusNotIn += ",Cart";
    }
    let currentRepId = $ctrl.salesrep
    ? $ctrl.salesrep.id
    : $ctrl.repId
    ? $ctrl.repId
    : undefined;
    if ($ctrl.managerId !== undefined && $ctrl.managerId) {
      currentRepId = undefined;
    }
    return {
      url: url,
      orderBy: null,
      disableQueryString: true,
      autoLoad: false,
      criteria: {
        uploaded: $ctrl.uploaded,
        toUpload: $ctrl.toUpload,
        StatusNotIn: statusNotIn,
        [`Status${$ctrl.mode === "Quote" ? "StartsWith" : "NotEqualTo"}`]:
          "Quote",
        retailerId: retailerId,
        repGroup: $ctrl.repGroup,
        currentRepId: currentRepId,
        vendorId: $ctrl.vendor ? $ctrl.vendor.id : undefined,
        DateRange: $ctrl.dateRange,
      },
      fields: orderConfig.fields || undefined,
      filters,
      onLoaded: (args) => $ctrl.onOrderTotalsLoaded(args),
    };
  }

  load() {
    return this.query.load.apply(this.query, arguments);
  }
  selectDateRange() {
    const $ctrl = this;
    $ctrl.query.criteria.DateRange = $ctrl.dateRange;
    $ctrl.query.processFilters();
    $ctrl.query.load(true);
  }

  filterStatus(status) {
    const $ctrl = this;
    $ctrl.query.criteria.StatusIn = status ? [status] : [];
    $ctrl.query.load(true);
    console.warn("filterStatus", status, { status, $ctrl });
  }
  filterErpStatus(status) {
    const $ctrl = this;
    $ctrl.query.criteria.ErpStatusIn = status ? [status] : [];
    $ctrl.query.load(true);
    console.warn("filterErpStatus", status, { status, $ctrl });
  }
  createOrder(model) {
    const $ctrl = this;
    $ctrl.$cart.createPrompt({
      retailer: $ctrl.customer,
      mode: $ctrl.mode,
      status: $ctrl.mode === "Quote" ? "Quote" : "Cart",
    });
  }
  bulkActions(model) {
    const $ctrl = this;
    return orderPicker({
      title: "Select Orders...",
      view: "table",
      backdrop: false,
      placement: "center",
      criteria: $ctrl.query.criteria,
    }).finally(() => $ctrl.query.load(true));
  }
  printOrder(order) {
    const $ctrl = this;
    return PrintOrderOptions({
      request: {
        id: order,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }
  // vendorReview(order) {
  //   const $ctrl = this;
  //   return VendorReviewOrders({
  //     request: {
  //       id: order,
  //       //IncludeImages: false,
  //       //IncludeBarcodes: false,
  //       //OrderBy: "strProductID"
  //     },
  //   });
  // }
	vendorReview(order) {
		const $ctrl = this;
		return VendorReviewOrderPrompt.open({ order: order }).then(function (obj) {
			$ctrl.query.load();
		});
	}

  reExport(order) {
    const $ctrl = this;
    return modals.confirm("Are you sure you want to re-export order: " + order.id + "?", "Re-Export Order").result.then(function() {
      $ctrl.bus.send("ReExportOrder.json", {
        CartId: order.id
      }).then(function(response) {
        $ctrl.load();
      });
    });
  }
  
  delete(order) {
    const $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to delete order: " + order.id + "?",
        "Delete Order"
      )
      .result.then(function () {
        //console.info("order", order);
        $ctrl.bus.send("DeleteOrder.json", {CartId: order.id}).then(function (response) {
          $ctrl.$cart.removeOrderFromSession(order.id);
          $ctrl.load();
        });
      });
  }
  vendorShipment(order) {
    const $ctrl = this;
    return VendorShipmentPrompt({ order: order });
  }
  processPayment(id) {
    let $ctrl = this;
    return ProcessPayment({id: id});
  }
  retrieveTokenInfo(token, cvv) {
    let $ctrl = this;
    return RetrieveTokenInfo({ token: token, cvv: cvv });
  }
  retrieveTokenExInfo(token, expiration, cvv) {
    let $ctrl = this;
    return RetrieveTokenExInfo({ token: token, expiration: expiration, cvv: cvv });
  }
  retrieveHostedPCIInfo(order) {
    let $ctrl = this;
    return RetrieveHostedPCIInfo({ 
      token: order.paymentMethodToken, 
      tokenizationCode: order.tokenizationCode,
      expiration: order.paymentMethodExpiration, 
      type: order.paymentMethodType, 
      name: order.paymentMethodName, 
      lastFour: order.paymentMethodLastFour 
    });
  }
  viewLogs(order) {
    let $ctrl = this;
    return OrderLogDetail({ order: order });
  }
  retailerForms(order) {
    let $ctrl = this;
    console.info("order.retailerId", order.retailerId, order.vendorId);
    return RetailerFormsPopup({
      retailerId: order.retailerId,
      vendorFormId: order.vendorId,
    });
  }
  showChanges(id) {
    let $ctrl = this;
    return OrderChangesPrompt({ id: id });
  }
  updateErpStatus(order) {
    const $ctrl = this;
    console.debug("BL*** order", order);
    $ctrl.bus.send("ChangeErpStatus", {
      CartId: order.id,
      ErpStatus: order.erpStatus
    }).then(() => $ctrl.query.load());
  }
}
